<template>
  <div>
    <DeleteProductModal
      :product-id="basicProductId"
      :deleting="deleting"
      v-on="{ submit: handleProductDelete }"
    />
  </div>
</template>

<script>
import { productMethods } from '@/store/adminHelper';
import DeleteProductModal from '@/components/Products/DeleteProductModal.vue';

export default {
  name: 'BasicProductDestroy',
  components: {
    DeleteProductModal,
  },
  props: {
    basicProductId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    deleting: false,
  }),
  methods: {
    ...productMethods,
    handleProductDelete(basicProductId) {
      this.deleting = true;
      this.deleteProduct({ productId: basicProductId })
        .then(() => {
          this.deleting = false;
          this.redirectToProductList();
        })
        .catch(() => {
          this.deleting = false;
        });
    },
    redirectToProductList() {
      this.$router.replace({ name: 'admin.products.basicProducts' });
    },
  },
};
</script>
